import React from 'react';
import { findPage, validateSnapshot } from '../../website-schema/src/index.js';
import { themeToCssVariables } from '../../website-theme-core/src/index.js';

export function SiteRenderer({ snapshot, pathname, registry, assetResolver, formSubmitBaseUrl, currentHost }) {
  const errors = validateSnapshot(snapshot);
  if (errors.length) return <RuntimeMessage title="Website configuration error" message={errors.join(' ')} />;
  const page = findPage(snapshot, pathname);
  if (!page) return <RuntimeMessage title="Page not found" message="The page you requested does not exist." />;

  const quickNotice = normalizeQuickNotice(snapshot.quickNotice);

  return <div className="sb-site" style={themeToCssVariables(snapshot.theme)}>
    {(page.blocks ?? []).filter((block) => block?.visibility?.hidden !== true).map((block) => {
      const Component = registry[block.type];
      if (!Component) return <UnknownBlock key={block.id || block.type} type={block.type} />;
      const rendered = <Component key={block.id || block.type} block={block} page={page} snapshot={snapshot} assetResolver={assetResolver} formSubmitBaseUrl={formSubmitBaseUrl} currentHost={currentHost} quickNotice={quickNotice} />;
      if (quickNotice?.displayMode === 'banner' && block?.type?.startsWith('header')) {
        return <React.Fragment key={block.id || block.type}>{rendered}<QuickNoticeBanner notice={quickNotice} /></React.Fragment>;
      }
      return rendered;
    })}
  </div>;
}

function normalizeQuickNotice(notice) {
  if (!notice || notice.enabled !== true || notice.archived === true) return null;
  const title = String(notice.title || '').trim();
  const body = String(notice.body || '').trim();
  if (!title && !body) return null;
  const displayMode = ['banner', 'hero-card', 'carousel-slide'].includes(notice.displayMode) ? notice.displayMode : 'banner';
  const tone = ['info', 'urgent'].includes(notice.tone) ? notice.tone : 'info';
  return {
    ...notice,
    title,
    body,
    displayMode,
    tone,
    action: notice.action?.label && notice.action?.href ? notice.action : null
  };
}

function QuickNoticeBanner({ notice }) {
  if (!notice) return null;
  return <aside className={`sb-quick-notice sb-quick-notice-banner sb-quick-notice-${notice.tone}`} aria-label={notice.tone === 'urgent' ? 'Urgent notice' : 'Notice'}>
    <div className="sb-shell sb-quick-notice-inner">
      <div><b>{notice.title || 'Notice'}</b>{notice.body ? <p>{notice.body}</p> : null}</div>
      {notice.action ? <a className="sb-quick-notice-link" href={notice.action.href}>{notice.action.label}</a> : null}
    </div>
  </aside>;
}

function UnknownBlock({ type }) {
  if (import.meta.env.PROD) return null;
  return <div className="sb-runtime-warning">Unsupported block: {type}</div>;
}

export function RuntimeMessage({ title, message }) {
  return <main className="sb-runtime-state"><div><span className="sb-state-mark">SB</span><h1>{title}</h1><p>{message}</p></div></main>;
}
